import script from "./DiskChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DiskChart.vue?vue&type=script&setup=true&lang=js"

import "./DiskChart.vue?vue&type=style&index=0&id=f5c554b4&lang=css"

const __exports__ = script;

export default __exports__